import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { PageLink, PageTitle } from "../../../../_metronic/layout/core";
import { PartnerAnalyticList } from "./partnerAnalyticList";

const companyBreadcrumbs: Array<PageLink> = [
  {
    title: "Subscribed Data",
    path: "/partnerAnalytics/list",
    isSeparator: false,
    isActive: false,
  },
  {
    title: "",
    path: "",
    isSeparator: true,
    isActive: false,
  },
];

const PartnerAnalyticPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path="list"
          element={
            <>
              <PageTitle breadcrumbs={companyBreadcrumbs}>Partner Analytics</PageTitle>
              <PartnerAnalyticList/>
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to="/partnerAnalytics/list" />} />
    </Routes>
  );
};

export default PartnerAnalyticPage;
